import script from "./UUniversalSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./UUniversalSelector.vue?vue&type=script&setup=true&lang=ts"

import "./UUniversalSelector.vue?vue&type=style&index=0&id=be9aea54&lang=css"

const __exports__ = script;

export default __exports__